//============================
//# imbokcashflowgr
//============================

export default interface CashFlowRiportGroupItem {
  id: number;
  name: string;
  group: number;
  month: number;
  remark: string;
  reportRow: number;
  planAmount: number;
  amount: number;
  isClosedMonth: boolean;
  showDetails: boolean;
}

export const CashFlowRiportGroupItemsDefaultProps: CashFlowRiportGroupItem = {
  id: 0,
  name: "-",
  group: 0,
  month: 0,
  remark: "-",
  reportRow: 0,
  planAmount: 0,
  amount: 0,
  isClosedMonth: false,
  showDetails: false,
}
